/** The compact agent cursor pill, screen marks and cursor control. */
export default {
  thinking: "Thinking…",
  answerSent: "Answer sent",
  answerLater: "Answer later",
  openConversation: "Open conversation",
  dismissCursor: "Dismiss cursor",
  questionStep: "Question {index} of {count}",
  yourAnswer: "Your answer…",
  toolFailed: "Tool failed",
  annotationNeedsScreenshot:
    "A screen annotation needs a screenshot. Return to that view, review a new capture, or remove the marks.",
  capturingAnnotations: "Capturing screen annotations…",
  marks: "Marks {numbers}",
  reviewScreenshot: "Review screenshot",
  removeMarks: "Remove marks",
  checkMarkedView: "Check that this shows the marked view.",
  screenForMarks: "Screen to associate with these marks",
  useThisScreenshot: "Use this screenshot",
  editAnnotation: "Edit annotation {number}",
  addComment: "Add a comment",
  commentOnAnnotation: "Comment on annotation {number}",
  commentForAnnotation: "Comment for annotation {number}",
  cursorControl: "Cursor control",
  cursorControlTitle: "May Denker move your physical pointer?",
  cursorControlDetail:
    "Denker will move your physical pointer to click or scroll. You can stop at any time.",
  allowForTask: "Allow for this task",
  alwaysAllow: "Always allow",
  alwaysAllowDetail:
    "Always allow applies to all Denker tasks on this Mac, including after restart. Change it in Settings → Runner. Consequential actions still require approval.",
  respondFailed: "That did not go through. Please try again.",
  escapeStopFailed: "Could not stop cursor control. Try Stop again.",
  startFailed: "Could not start cursor control. Please stop and try again.",
  stopFailed: "Could not stop. Try again or press Esc.",
  stop: "Stop",
  stopCursorControl: "Stop Denker cursor control",
  stopDenker: "Stop what Denker is doing",
  stopCursorControlTitle: "Stop cursor control (Esc)",
  stopDenkerTitle: "Stop what Denker is doing (Esc)",
} as const;
